import { useAtomValue } from 'jotai'
import { themeSettingAtom } from '@/atoms/theme'
import { Toaster as Sonner } from 'sonner'

type ToasterProps = React.ComponentProps<typeof Sonner>

const Toaster = ({ ...props }: ToasterProps) => {
  const themeSetting = useAtomValue(themeSettingAtom)

  return (
    <Sonner
      theme={themeSetting}
      className="toaster group"
      richColors
      mobileOffset={64}
      toastOptions={{
        classNames: {
          toast:
            'group toast !px-6 group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg',
          description: 'group-[.toast]:text-muted-foreground',
          actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
          cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground'
        }
      }}
      {...props}
    />
  )
}

export { Toaster }
